module.exports = __webpack_public_path__ + "img/popup10.9abd8976.png";